export default "__VITE_ASSET__BrRCyHvz__"